import run from '../../utilities/run';
import $ from 'jquery';
import _ from 'underscore';
import render from "../../utilities/render";
import typeAheadSource from "../../utilities/typeAheadSource";
import { setSwitchery,enableSwitchery,disableSwitchery, instantiateSwitchery} from '../../utilities/instantiateSwitchery';
import {handleDisplayFor, resetDisplay, hide, setOptionsForSelect} from "../../utilities/selectorHelpers";
import {isPresent} from "../../utilities/general";
import { isNull } from 'util';
import {resetAccessorialSection} from "./preparationTab.js";
const modalHtml = require("../../sharedHtml/modal.html");
const changeInternationalCountryModalBody = require("./html/modalOrderChangeToInternational.html");

export default function DestinationTab(wizard) {
	const self = this;
	const wizardEl = wizard.getWizardElement();
	const facilityTypeahead = wizardEl.find("#destinationTab-typeahead");
	const isInternationalOrder =  $("#create-order-form").data("is-international-order");
	const targetArray = [".b2b-section, .address-section", ".b2c-section, .address-section"];
	const orderTypeSelect = $("#destination-tab-order-type-select");
	const orderTypeList = orderTypeSelect.data('options');
	const consolidatedOrderTypeList = orderTypeSelect.data("consolidated-order-type-list");
	const groupedOrderTypeList = _.groupBy(consolidatedOrderTypeList, 'ortTypeCode');
	const defaultContry  =  orderTypeSelect.data('default-country');
	const usaStates  =  orderTypeSelect.data('usa-states');
	const caProvinces  =  orderTypeSelect.data('ca-provinces');
	const countriesPhoneCodeSelect = $(".destination-tab-country-phone-code");
	const countriesPhoneCode  =  orderTypeSelect.data('country-phone-code-list');
	const productsTabEl = wizardEl.find('.products-tab');
	const shippingTabEl = wizardEl.find('.shipping-tab');
	const isChannelOrder = wizardEl.data("is-channel-order");
	const productsTableProductsTab = $("#product-bundle-row");
	const contactName = $("#destination-tab-contactName");
	const customerEmail = $("#destination-tab-btob-customerEmail");
	const phoneNumber= $("#destination-tab-btob-customerPhoneNumber");
	//const country= $("#destination-tab-country");
	const address1= $("#destination-tab-address1");
	const address2= $("#destination-tab-address2");
	const city= $("#destination-tab-city");
	const zipCode= $("#destination-tab-zipCode");
	const stateTextInput = $("#destination-tab-stateText");
	const stateSelect = $("#destination-tab-state");
	const customerPhoneNumber =  $("#destination-tab-customerPhoneNumber");
	const orderDetailsForEdit = $("#create-order-form").data("edit-order-details");
  const retailerfacilitiesList = $("#create-order-form").data("retailer-facility-addresses");
  const destinationTabCountry = $("#destination-tab-country");
  const countries = destinationTabCountry.data('options');
  const sendTrackingInfoCheckB2b = $("#destination-tab-btob-sendTrackingInfo");
	const emailTextBoxB2b = $("#destination-tab-btob-customerEmail" );
  	//B2C fields
  const customerName = wizardEl.find('.customerName');
  const company = wizardEl.find('.company');
  const sendTrackingInfoCheck = $("#destination-tab-sendTrackingInfo");
	const emailTextBox = $("#destination-tab-customerEmail" );
	const facilityTypeaheadDiv = wizardEl.find(".destinationTab-typeahead-div");
	const facilityTypeTextBoxDiv = wizardEl.find(".destinationTabTextBoxDiv");
	const facilityTypeTextBox = wizardEl.find(".destination-tab-facility-type-text-box");

	const orderReferenceNumber = wizardEl.find("#orderReferenceNumber");
	let previousCountry =  "";
	wizardEl.on("click", '.change-country-modal-cancel', changeCountryCancelModal);
  wizardEl.on("click", '.change-country-modal-continue', changeCountryContinueModal);
	wizardEl.on("click", '.change-country-modal-continue', changeCountryContinueModal);
	const getShipmentMethodsUrl = $('#create-order-form').data('get-shipment-methods-url');
	const getServiceLevelsUrl = $('#create-order-form').data('get-service-levels-url');
  const hiddenAddressInput = $("#order-validated-address");
  const internationalShippingEnabled = wizardEl.data("is-international-order");
  const internationalmsg = wizardEl.find(".destination-tab-international-msg");
  const validationReqdCountries = $("#create-order-form").data("validation-reqd-countries");
	self.init = function() {
		loadRetailerFacilities();
		loadOrderTypeList();
		setPhoneNumberInputMask();
		loadCountryPhoneCodesList();
		loadCountriesList();
		handleCountryChange();
		destinationTabCountry.on("change", handleCountryChange);
		setPhoneCodeValidation();
		facilityTypeTextBoxDiv.hide();
		setDestinationTab(orderDetailsForEdit.orderDetails);
		if(!_(orderDetailsForEdit.orderDetails).isEmpty()) {
			loadShippingService(orderDetailsForEdit.orderDetails);
		}

	};

	function loadShippingService(orderDetails){
		const destTabOrderType = $("#destination-tab-order-type-select");
		const destTabDropShipFlag = $("#dropShipFlag");
		loadShipmentMethods(destTabOrderType.val(),destTabDropShipFlag.prop("checked"));
		loadServiceLevels(destTabOrderType.val(),destTabDropShipFlag.prop("checked"));


	}

	function loadShipmentMethods(orderType, dropShipFlag){
		const shippingMethodUsaId = $("#shipping-tab-shipping-method-with-usa");
		$.ajax({
		url: getShipmentMethodsUrl,
		type: 'POST',
		dataType: 'JSON',
		data: { orderType, dropShipFlag },
		success: function(data){
			shippingMethodUsaId.empty();
			const option = $('<option /\>');
			option.attr('value', "-1").text("Please select shipping method");
			option.attr('disabled', 'disabled')
			option.attr('selected', 'selected')
			shippingMethodUsaId.append(option);
			$.each(data, function(index, value) {
					const option = $('<option /\>');
					option.attr('value', value.cdmValue).text(value.cdmMeaning);
					shippingMethodUsaId.append(option);
			});
		}
		});
	}

	function loadServiceLevels(orderType, dropShipFlag, shippingMethod){
		const serviceLevelsUsaId = $("#shipping-tab-shipping-service-level-with-usa");
		$.ajax({
		url: getServiceLevelsUrl,
		type: 'POST',
		dataType: 'JSON',
		data: { orderType, dropShipFlag },
		success: function(data) {
			serviceLevelsUsaId.empty();
			const option = $('<option /\>');
			option.attr('value', "-1").text("Select from Service Levels");
			option.attr('disabled', 'disabled')
			option.attr('selected', 'selected')
			serviceLevelsUsaId.append(option);
			$.each(data, function(index, value) {
					const option = $('<option /\>');
					option.attr('value', value.cdmValue).text(value.cdmMeaning);
					serviceLevelsUsaId.append(option);
			});
		}
		});

	}
	function loadRetailerFacilities(){
		setOptionsForSelect({
	    	selectElement: facilityTypeahead,
	    	list: retailerfacilitiesList,
	    	valueDataKey: "id",
	    	textDataKey: "text"
	  	});
	}

	facilityTypeahead.on("select2:select", function(e) {
		let selectedB2BFacilityAttributes = retailerfacilitiesList.find(obj => obj.id == e.params.data.id);
		setB2BDestinationTabForNewOrder(selectedB2BFacilityAttributes);
	});


	//NOTE: change event, so making it send functional jobs to another function
	function select2FieldChange() {
		handleSelect2IndividualValidate($(this));
	}

    // NOTE: since select2 components are tricky, we specifically target them as well with the EditChecker component, and also have to validate them individually
	function handleSelect2IndividualValidate(selectField) {
		selectField.valid();
		EditChecker.setPageDirty();
	  };


	function loadOrderTypeList(){
		$.each(orderTypeList, function(index, object) {
			let dataAttr;
			if(object.ortTypeCode != 'B2B'){
	 			dataAttr = targetArray[1];
			}else{
				dataAttr = targetArray[0];
			}
			let value = `${object.ortTypeCode}-${object.ortRetailerName || object.ortName}`;
			const option = $('<option /\>');
			option.data('quick-toggler-target', dataAttr);
			option.attr('value', object.ortTypeCode).text(value);
			orderTypeSelect.append(option);
		});
	}

	/*const retailerTypeSelect = $("#destination-tab-retialer-type-select");
	const retailerTypeList = retailerTypeSelect.data('options');

	$.each(retailerTypeList, function(index, value) {

		const option = $('<option /\>');
		if(value == "Other")
		{
			option.data('quick-toggler-target', '#retailer-other-outer');
		}
		option.attr('value', value).text(value);
		retailerTypeSelect.append(option);
	});*/

	function loadCountryPhoneCodesList(){
		$(countriesPhoneCode).each(function(){
		 let option = $('<option />');
		 option.attr('value', this.conPhoneCode).text(this.conPhoneText);
		 countriesPhoneCodeSelect.append(option);
		});
	}

	function loadCountriesList(){
		$(countries).each(function(){
			 let option = $('<option />');
			 option.attr('value', this.conId).text(this.conName);
			 if(isInternationalOrder)
			 {
				 destinationTabCountry.append(option);
			 }
			 else{
				 if(this.conId =="1")
				 {
					destinationTabCountry.append(option);
				 }
			 }
		});
	}



	function setStates(countryVal) {
		const destinationTabStatesSelect = $("#destination-tab-state");
		destinationTabStatesSelect.html('');
		let defaultSelectText = "";
		if(countryVal == "1") {
			defaultSelectText = "Select State";
		} else {
			defaultSelectText = "Select Province";
		}
		let option = $('<option />');
		option.attr('value', "-1").text(defaultSelectText);
		option.attr('selected','selected');
		option.attr('disabled','disabled');
		destinationTabStatesSelect.append(option);
		if(countryVal == "1")
		{
			$(usaStates).each(function(){
				 let option = $('<option />');
				 option.attr('value', this.cdmValue).text(this.cdmMeaning);
				 destinationTabStatesSelect.append(option);
			});
		}
		else if(countryVal == "2")
		{
			$(caProvinces).each(function(){
				 let option = $('<option />');
				 option.attr('value', this.cdmValue).text(this.cdmMeaning);
				 destinationTabStatesSelect.append(option);
			});
		}
	}
	
	function handleCountryChange(e){
		const products = productsTableProductsTab.find('.product-data-row');
		const countryNewVal = $('#destination-tab-country  :selected').val();
		if(products.length > 0 && previousCountry == 1 && destinationTabCountry.val() != 1) {
        	changeInternationalCountryModal.modal('show');
        }

		handleSwitchingStateInput();
    	triggerProductTabSwappingForCountry();
		showInternationlShippingConfigMessage();
		let originalCountryOfOrder, orderDetails;
		if(!_(orderDetailsForEdit).isEmpty() && !_(e).isUndefined()) {
			orderDetails = orderDetailsForEdit.orderDetails;		
			originalCountryOfOrder = orderDetails.ordShipToCountry;
			if((originalCountryOfOrder != null && originalCountryOfOrder !='US') && countryNewVal == 1 && isChannelOrder == true) {
				triggerDisableChannelSwitch();
			}
		}
	
		resetAccessorialSection();
	}

	function triggerProductTabSwappingForCountry(){
		productsTabEl.trigger("country-select-change");
	}
	function triggerDisableChannelSwitch() {
		let retainChannelShipmentCheck = shippingTabEl.find("#channelShippingMethodCheck");
		if(retainChannelShipmentCheck.length > 0) { 
		instantiateSwitchery(retainChannelShipmentCheck);
		setSwitchery(retainChannelShipmentCheck, false);
		disableSwitchery(retainChannelShipmentCheck);
		retainChannelShipmentCheck.trigger("change");
		}
		
	}


  // create and initialize modal when change country to International
  const changeInternationalCountryModal = $(render(
    modalHtml, {
      modalDialogClass: 'q-modal-dialog-500',
      title: 'Products will be lost',
      leftAlignTitle: true,
      body: changeInternationalCountryModalBody,
      topCloseBtn: false,
      autoHideTop: true,
      footerBtns:'<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide change-country-modal-cancel">Cancel</a><a href="#" class="base-btn purple-btn modal-auto-hide change-country-modal-continue">Continue</a>'
    }
  ));

  wizardEl.append(changeInternationalCountryModal);

	function handleSwitchingStateInput(){
		let isValidCountry = false;
		let countryId=""; 
		let checkZipCode = false;
		var countryVal = $('#destination-tab-country  :selected').val();
		previousCountry = countryVal;
		$(countries).each(function() {
			if(this.conId.toString() === countryVal.toString()) {
			  countryId = this.conCode.toString();
			  if(this.conPostalCodeRequired.toString() === "Y"){
				checkZipCode=true;
			  }
			  return false;
			} 
		  });
		$(validationReqdCountries).each(function() {
			if(this.cdmValue.toString() === countryId.toString()) {
			  isValidCountry = true;
			  return false;
			} 
		  });
		  if(isValidCountry){
			$(".country-not-supported-primary").hide();        
		  }else{
			$(".country-not-supported-primary").show();
		  }
		if(countryVal == "1" || countryVal == "2")
		{

			$(".destination-tab-stateText-wrapper").hide();
			$(".destination-tab-state-wrapper").show();
			setStates(countryVal);
			$(".destination-tab-mandatory-label").show();
			$("#destination-tab-zipCode").prop('required',true);
		}
		else
		{
			$(".state-label").hide();
			if(checkZipCode){
			$(".destination-tab-stateText-wrapper").show();
			$(".destination-tab-state-wrapper").hide();
			$(".zipcode-label").show();
			$("#destination-tab-zipCode").prop('required',true);
		  }else {
			$(".destination-tab-stateText-wrapper").show();
			$(".destination-tab-state-wrapper").hide();
			$(".zipcode-label").hide();
			$("#destination-tab-zipCode").prop('required',false);
		  }}
	}



	sendTrackingInfoCheck.change(function() {
		if(sendTrackingInfoCheck.is(':checked'))
		{
			emailTextBox.rules( "add", {
			  required: true,
			   messages: {
				required: "This field is required."
				  }
			});
		}
		else{

			emailTextBox.rules("remove");
		}
	});


	sendTrackingInfoCheckB2b.change(function() {
		if(sendTrackingInfoCheckB2b.is(':checked'))
		{
			emailTextBoxB2b.rules( "add", {
			  required: true,
			   messages: {
				required: "This field is required."
				  }
			});
		}
		else{
			emailTextBoxB2b.rules("remove");
		}
	});

	// Need USA as default - defaultContry is coming from jsp
	destinationTabCountry.val(defaultContry).trigger('change');
	countriesPhoneCodeSelect.val("+1").trigger('change');

	function changeCountryCancelModal() {
    destinationTabCountry.val(1).trigger('change');
  }

  function changeCountryContinueModal() {
      EditChecker.setPageDirty();
      productsTableProductsTab.empty();
      changeInternationalCountryModal.modal('hide');
  }

	orderTypeSelect.on('change', function(e){

		showHideDropFlag(orderTypeSelect.val(),$("#destination-tab-order-type-select option:selected").text());
		setPhoneCodeValidation();
	});

	countriesPhoneCodeSelect.on('change', function(e){
		setPhoneCodeValidation();
	});

	function showHideDropFlag(cotCode,name){
		let dropShipSection = $('#dropShipSection');

		//Get only the code for this order type code or an empty list
		const orderTypeList = groupedOrderTypeList[cotCode] || [];

		let showDropShipFlag = false;
		let dropShipAvail = {
			"Y": false,
			"N": false
		};

		$.each(orderTypeList, (index, value) => {
			if(!isNull(value.ortDropShip)){
				showDropShipFlag = true;

				if(value.ortDropShip){
					dropShipAvail.Y = true;
				}else{
					dropShipAvail.N = true;
				}
			}
		});

		const dropShipFlagEl = dropShipSection.find("#dropShipFlag");
		instantiateSwitchery(dropShipFlagEl);
		if(showDropShipFlag){
			dropShipSection.removeClass('hidden');
			setSwitchery(dropShipFlagEl, false);
			disableSwitchery(dropShipFlagEl);
			if(dropShipAvail.Y && dropShipAvail.N){
				enableSwitchery(dropShipFlagEl);
			} else if (dropShipAvail.Y) {
				setSwitchery(dropShipFlagEl, true);
			}
		}else{
			//Reset the elements
			dropShipSection.addClass('hidden');
			setSwitchery(dropShipFlagEl, false);
			disableSwitchery(dropShipFlagEl);
		}
	}
	function setPhoneNumberInputMask(){
		phoneNumber.inputmask({
			mask: "(999) 999-9999"
		  });
		  customerPhoneNumber.inputmask({
			mask: "(999) 999-9999"
			  });
	}

	function setPhoneCodeValidation(){		
		if($(".destination-tab-country-phone-code-b2b").val()=="+1"){
			phoneNumber.attr("placeholder", "(999) 999-9999");
			phoneNumber.addClass("phoneUS");
			phoneNumber.removeClass("phoneNonUS");
			phoneNumber.inputmask({
				mask: "(999) 999-9999"
			  });
		}else if($(".destination-tab-country-phone-code-b2b").val()!="+1"){ 
			/*
				Please dont just add else, because if order type is other than b2b, then  
				the else condition will be always true
			*/
			phoneNumber.removeAttr("placeholder");
			phoneNumber.removeClass("phoneUS");
			phoneNumber.addClass("phoneNonUS");
			phoneNumber.inputmask({
				mask: ""
			  });
			let val= phoneNumber.val();	
					
			if(val){
			  let v=   val.replace(/[- )(]/g,'');
			  v=v.replace(/[^0-9.]/g, "");
			  phoneNumber.val(v);
			   }
		}
		if($(".destination-tab-country-phone-code-b2c").val()=="+1"){
			customerPhoneNumber.attr("placeholder", "(999) 999-9999");
			customerPhoneNumber.addClass("phoneUS");
			customerPhoneNumber.removeClass("phoneNonUS");
			customerPhoneNumber.inputmask({
				mask: "(999) 999-9999"
				  });
		}else if($(".destination-tab-country-phone-code-b2c").val()!="+1"){
			/*
				Please dont just add else, because if order type is other than b2c, then  
				the else condition will be always true
			*/
			customerPhoneNumber.removeAttr("placeholder");
			customerPhoneNumber.removeClass("phoneUS");
			customerPhoneNumber.addClass("phoneNonUS");						
			customerPhoneNumber.inputmask({
				mask: ""
				  });
			let val= customerPhoneNumber.val();
			if(val){
			  let v=   val.replace(/[- )(]/g,'');
			  v=v.replace(/[^0-9.]/g, "");
			  customerPhoneNumber.val(v);
				   }
		}
	}

	if(!$.isEmptyObject(orderDetailsForEdit)){
	  	const order = orderDetailsForEdit.orderDetails;
	  	const error = orderDetailsForEdit.error;
	  	setDestinationTab(order);
	}

	function setDestinationTab(data){
		if(isPresent(data)){
			orderTypeSelect.val(data.ordOrderType);
			const order = orderDetailsForEdit.orderDetails;

			if(data.ordOrderType!='B2B'){
				setB2CDestinationTabForExistingOrder(order);
				setCustomerAddress(data);
				showHideDropFlag(data.ordOrderType, data.ordOrtName);

			}else{
				if(isPresent(order)){
					setB2BDestinationTabForExistingOrder(order);
					setCustomerAddress(data);
					showHideDropFlag(data.ordOrderType, data.ordOrtName);
				}
			}
		}
	}

	function setB2CDestinationTabForExistingOrder(data){
		customerName.val(data.ordShipToName);
  		company.val(data.ordShipToCompany);
  		emailTextBox.val(data.ordShipToEmail);
  		if(data.ordShipToPhone.length>10 && data.ordShipToPhone.includes("+") ){
			customerPhoneNumber.val(data.ordShipToPhone.substring(2, data.ordShipToPhone.length));
		}else{
			customerPhoneNumber.val(data.ordShipToPhone);
		  }		
  		if(data.ordSendTrackingInfo==1){
			sendTrackingInfoCheck.prop("checked", true);
		}else{
			sendTrackingInfoCheck.prop("checked", false);
		}

	}

	function setB2BDestinationTabForExistingOrder(data){
		let ordShipToCompany = retailerfacilitiesList.find(obj => obj.id == data.ordShipToCompany);
		if(isPresent(ordShipToCompany)){
			facilityTypeaheadDiv.show();
			facilityTypeahead.val(data.ordShipToCompany).trigger("change");
		}else{
			facilityTypeaheadDiv.hide();
			facilityTypeTextBoxDiv.show();
			facilityTypeTextBox.val(data.ordShipToCompany);
		}
		contactName.val(data.ordShipToName);
		customerEmail.val(data.ordShipToEmail);
		if(data.ordSendTrackingInfo==1){
			sendTrackingInfoCheckB2b.prop("checked", true);
		}else{
			sendTrackingInfoCheckB2b.prop("checked", false);
		}		
		if(data.ordShipToPhone.length>10 && data.ordShipToPhone.includes("+")){
			phoneNumber.val(data.ordShipToPhone.substring(2, data.ordShipToPhone.length));
		}else{
			phoneNumber.val(data.ordShipToPhone);
		  }	
	}

	function setB2BDestinationTabForNewOrder(data){
		contactName.val(data.contactname);
		customerEmail.val(data.emailaddress);
		phoneNumber.val(data.phonenumber);
		destinationTabCountry.val(data.country).trigger("change");
		if(data.country == "1" || data.country == "2"){
			stateSelect.val(data.state).trigger("change");
		}else{
			stateTextInput.val(data.state);
		}
		address1.val(data.address1);
		address2.val(data.address2);
		city.val(data.city);

		zipCode.val(data.postalcode);
		countriesPhoneCodeSelect.val(data.phonecode).trigger("change");
	}

	function setCustomerAddress(data){
    orderReferenceNumber.val(data.ordParOrderNumber);
    orderReferenceNumber.prop('readonly', true);
		let facilityCountry = countries.find(obj => obj.conCode == data.ordShipToCountry);
  	destinationTabCountry.val(facilityCountry.conId).trigger("change");
		if(facilityCountry.conId == "1" || facilityCountry.conId == "2"){
			stateSelect.val(data.ordShipToState).trigger("change");
		}else{
			stateTextInput.val(data.ordShipToState);
		}
		address1.val(data.ordShipToAddress1);
		address2.val(data.ordShipToAddress2);
		city.val(data.ordShipToCity);
		zipCode.val(data.ordShipToZip);
		if(isPresent(data.ordShipToCountryPhoneCode)){
			countriesPhoneCodeSelect.val(data.ordShipToCountryPhoneCode).trigger("change");
		}else{
			countriesPhoneCodeSelect.val("+1").trigger("change");
    }

    setAddressValidationHiddenFieldValueOnEdit(data);
  }

  function setAddressValidationHiddenFieldValueOnEdit(data){
    let addressResponse = {};
    addressResponse = {
      address1: data.ordShipToAddress1,
      address2: data.ordShipToAddress2,
      stdCity: data.ordShipToCity,
      zip: data.ordShipToZip,
      state: data.ordShipToState,
      stdCountry: destinationTabCountry.val()
    }
    hiddenAddressInput.val(JSON.stringify(addressResponse));
  }

  self.checkForAddressValidationBusinessException = function(orderDetailsForEdit){
    let addressValidationRequired = false;
    if(orderDetailsForEdit!=null && orderDetailsForEdit.exceptionLog!=null){
      _.each(orderDetailsForEdit.exceptionLog, (exception)=>{
        if((exception.code==="ERR-ORD-0043" || exception.code==="ERR-ORD-0044") && exception.status!=="Resolved"){
          addressValidationRequired = true;
        }
      });
    }

    return addressValidationRequired;
  }

  function showInternationlShippingConfigMessage(){
    if(!internationalShippingEnabled && $('#destination-tab-country  :selected').val() !="1"){
      internationalmsg.show();
    }else{
      internationalmsg.hide();
      validateHsCodeErrorMessage();
    }
  }

  function validateHsCodeErrorMessage(){
    const products = productsTableProductsTab.find('.product-data-row');
    products.each(function(){
      const product = $(this);
      if(product.find(".hs-code-missing").length !=0 && $('#destination-tab-country  :selected').val() =="1"){
        product.find(".hs-code-missing").remove();
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/pages/order/destinationTab.js